export const replaceBrToLineBreak = (text: string): string =>
  text.replaceAll(/<br(.*?)>/g, '\n');